module.exports = __webpack_public_path__ + "img/4-5.8c5a1cdf.svg";